import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { ConcernTreatmentRanking } from '../../contracts/display'
import { OperationType } from '../../contracts/treatment'

export const getConcernTreatments = asBuilder<ConcernTreatmentRanking>((): ConcernTreatmentRanking => {
  return faker.helpers.multiple(
    () => ({
      treatmentId: faker.number.int(),
      name: faker.string.uuid(),
      description: faker.helpers.arrayElement([faker.string.uuid(), null]),
      suggestionCountPerCycle: faker.helpers.arrayElement([faker.string.uuid(), null]),
      averagePrice: faker.string.uuid(),
      operationType: faker.helpers.enumValue(OperationType),
    }),
    { count: 3 },
  )
})
